const eventType = require('@transfeeradev/api-enums/eventType');
const moment = require('@transfeeradev/moment');
const { v4: uuidV4 } = require('uuid');

class EventFormatterService {
  static format(instance, options, action, service) {
    const event = {
      id: uuidV4(),
      entity: instance.constructor.name,
      date: moment().format(),
      action,
      service,
      after: instance.dataValues,
      complement: {}
    };

    if (options?.session) {
      event.complement.ip = options.session.ip;
      event.complement.agent = options.session.agent;
    }

    if (options?.session?.user) {
      event.complement.user = {
        id: options.session.user.id,
        name: options.session.user.name,
        email: options.session.user.email
      };
    }

    if (options?.session?.company) {
      event.complement.company = {
        id: options.session.company.id,
        name: options.session.company.name
      };
    }

    if (action === eventType.UPDATE) {
      event.previous = instance._previousDataValues;
    }

    return event;
  }
}

module.exports = EventFormatterService;
